var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifiFair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.318 352.002C284.972 352.002 256.316 380.658 256.316 416.002S284.972 480.002 320.318 480.002C355.662 480.002 384.32 451.346 384.32 416.002S355.662 352.002 320.318 352.002ZM320.32 192C250.07 192 182.414 217.562 129.82 264C116.57 275.719 115.32 295.938 127.007 309.188C138.789 322.438 158.976 323.688 172.195 312C213.07 275.875 265.695 256 320.32 256S427.57 275.875 468.445 312C474.539 317.375 482.101 320 489.632 320C498.476 320 507.289 316.344 513.632 309.188C525.32 295.938 524.07 275.719 510.82 264C458.226 217.562 390.57 192 320.32 192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiFair);
export default __webpack_public_path__ + "static/media/wifi-fair.dbcb545b88267a3de7cae89a3d4dfed0.svg";
export { ForwardRef as ReactComponent };